import { HIDDEN_EDITORIAL_MARKER_REGEX_SOURCE as SHARED_HIDDEN_EDITORIAL_MARKER_REGEX_SOURCE } from './editorialMarkerGrammar'

export const LO_MARKER_REGEX_SOURCE = String.raw`\/?Lo[–-]\d+(?:[.\-–]+\d+)*(?:\/)?`
export const HIDDEN_EDITORIAL_MARKER_REGEX_SOURCE = SHARED_HIDDEN_EDITORIAL_MARKER_REGEX_SOURCE

const LO_MARKER_STRICT_REGEX = new RegExp(`^${LO_MARKER_REGEX_SOURCE}$`, 'i')
const HIDDEN_EDITORIAL_MARKER_STRICT_REGEX = new RegExp(`^${HIDDEN_EDITORIAL_MARKER_REGEX_SOURCE}$`, 'i')

export const shouldHideMarkerInWorkspace = (marker: string): boolean => {
  const normalized = marker.trim()
  if (!normalized) {
    return true
  }
  return LO_MARKER_STRICT_REGEX.test(normalized) || HIDDEN_EDITORIAL_MARKER_STRICT_REGEX.test(normalized)
}
